export const apiConfig = {
  /**
   * Base URL for all API requests, including protocol.
   * Example: "https://my.streamhoster.com"
   *
   * Uses window.location.origin to automatically match the current domain:
   * - https://my.streamhoster.com (direct customers)
   * - https://my.themediacdn.com (white-label for resellers)
   *
   * Same-origin requests avoid CORS issues since the Scala backend
   * serves both the dashboard HTML and API endpoints.
   */
  baseUrl: window.location.origin,
  version: 1,
} as const;
